import {ComponentType} from "react";
import CreateTestSchool from "../../features/tests/create/pages/CreateTestSchool";
import CreateTestTraining from "../../features/tests/create/pages/CreateTestTraining";
import CreateTestLiteracy from "../../features/tests/create/pages/CreateTestLiteracy";
import CreateTestDigitalLiteracy from "../../features/tests/create/pages/CreateTestDigitalLiteracy";
import CreateTestNumericLiteracy from "../../features/tests/create/pages/CreateTestNumericLiteracy";
import CreateTestScientificLiteracy from "../../features/tests/create/pages/CreateTestScientificLiteracy";
import CreateTestBac from "../../features/tests/create/pages/CreateTestBac";
import CreateTestEvaluation from "../../features/tests/create/pages/CreateTestEvaluation";
import CreateTestCustom from "../../features/tests/create/pages/CreateTestCustom";

export interface CreateTestProps {
    testType: string;
}

export type TestType =
    | "school"
    | "bac"
    | "evaluate"
    | "training"
    | "literacy"
    | "digitalLiteracy"
    | "numericLiteracy"
    | "scientificLiteracy"
    | "customTest";

export interface TestTab {
    path: string;
    label: string;
}

export interface TestTypeConfig {
    id: TestType;
    testTypeId: number;
    typeId: number;
    name: string;
    basePath: string;
    addTestPath: string;
    tabs: TestTab[];
    title: string;
    component: ComponentType<CreateTestProps>;
    componentTestType: string;
    canShowReport: boolean;
    usesGrade: boolean;
    testMode?: string;
}

export const TEST_TYPES: Record<TestType, TestTypeConfig> = {
    school: {
        id: "school",
        typeId: 0,
        testTypeId: 1,
        name: "Teste școlare",
        basePath: "/teste",
        addTestPath: "/teste/adauga-test",
        tabs: [
            {path: "/teste", label: "Teste active"},
            {path: "/teste/teste-finalizate", label: "Teste finalizate"},
            {path: "/teste/istoric-teste", label: "Istoric teste"},
        ],
        title: "școlar",
        component: CreateTestSchool,
        componentTestType: "scolare",
        canShowReport: true,
        usesGrade: false,
        testMode: "school",
    },

    bac: {
        id: "bac",
        typeId: 21,
        testTypeId: 3,
        name: "Teste pregătire BAC",
        basePath: "/teste-bac",
        addTestPath: "/teste-bac/adauga-test",
        tabs: [
            {path: "/teste-bac", label: "Teste active"},
            {path: "/teste-bac/teste-finalizate", label: "Teste finalizate"},
            {path: "/teste-bac/istoric-teste", label: "Istoric teste"},
        ],
        title: "bacalaureat",
        component: CreateTestBac,
        componentTestType: "bac",
        canShowReport: true,
        usesGrade: true,
    },

    evaluate: {
        id: "evaluate",
        typeId: 20,
        testTypeId: 4,
        name: "Teste pregătire Evaluare Națională (VIII)",
        basePath: "/teste-evaluare",
        addTestPath: "/teste-evaluare/adauga-test",
        tabs: [
            {path: "/teste-evaluare", label: "Teste active"},
            {path: "/teste-evaluare/teste-finalizate", label: "Teste finalizate"},
            {path: "/teste-evaluare/istoric-teste", label: "Istoric teste"},
        ],
        title: "evaluare națională (VIII)",
        component: CreateTestEvaluation,
        componentTestType: "evaluate",
        canShowReport: true,
        usesGrade: true,
    },

    training: {
        id: "training",
        typeId: 23,
        testTypeId: 2,
        name: "Teste de antrenament",
        basePath: "/teste-antrenament",
        addTestPath: "/teste-antrenament/adauga-test",
        tabs: [
            {path: "/teste-antrenament", label: "Teste active"},
            {path: "/teste-antrenament/teste-finalizate", label: "Teste finalizate"},
            {path: "/teste-antrenament/istoric-teste", label: "Istoric teste"},
        ],
        title: "antrenament",
        component: CreateTestTraining,
        componentTestType: "scolare",
        canShowReport: false,
        usesGrade: false,
        testMode: "training",
    },

    literacy: {
        id: "literacy",
        typeId: 19,
        testTypeId: 5,
        name: "Teste de literație",
        basePath: "/teste-literatie",
        addTestPath: "/teste-literatie/adauga-test",
        tabs: [
            {path: "/teste-literatie", label: "Teste active"},
            {path: "/teste-literatie/teste-finalizate", label: "Teste finalizate"},
            {path: "/teste-literatie/istoric-teste", label: "Istoric teste"},
        ],
        title: "literație",
        component: CreateTestLiteracy,
        componentTestType: "literatie",
        canShowReport: true,
        usesGrade: true,
        testMode: "literacy",
    },

    digitalLiteracy: {
        id: "digitalLiteracy",
        typeId: 24,
        testTypeId: 6,
        name: "Teste de literație digitală",
        basePath: "/teste-literatie-digitala",
        addTestPath: "/teste-literatie-digitala/adauga-test",
        tabs: [
            {path: "/teste-literatie-digitala", label: "Teste active"},
            {path: "/teste-literatie-digitala/teste-finalizate", label: "Teste finalizate"},
            {path: "/teste-literatie-digitala/istoric-teste", label: "Istoric teste"},
        ],
        title: "literație digitală",
        component: CreateTestDigitalLiteracy,
        componentTestType: "literatieDigitala",
        canShowReport: true,
        usesGrade: true,
        testMode: "digital-literacy",
    },

    numericLiteracy: {
        id: "numericLiteracy",
        typeId: 41,
        testTypeId: 8,
        name: "Teste de literație numerică",
        basePath: "/teste-literatie-numerica",
        addTestPath: "/teste-literatie-numerica/adauga-test",
        tabs: [
            {path: "/teste-literatie-numerica", label: "Teste active"},
            {path: "/teste-literatie-numerica/teste-finalizate", label: "Teste finalizate"},
            {path: "/teste-literatie-numerica/istoric-teste", label: "Istoric teste"},
        ],
        title: "literație numerică",
        component: CreateTestNumericLiteracy,
        componentTestType: "numericLiteracy",
        canShowReport: true,
        usesGrade: false,
        testMode: "numerical-literacy",
    },

    scientificLiteracy: {
        id: "scientificLiteracy",
        typeId: 48,
        testTypeId: 9,
        name: "Teste rapide de literație științifică",
        basePath: "/teste-literatie-stiintifica",
        addTestPath: "/teste-literatie-stiintifica/adauga-test",
        tabs: [
            {path: "/teste-literatie-stiintifica", label: "Teste active"},
            {path: "/teste-literatie-stiintifica/teste-finalizate", label: "Teste finalizate"},
            {path: "/teste-literatie-stiintifica/istoric-teste", label: "Istoric teste"},
        ],
        title: "rapid literație științifică",
        component: CreateTestScientificLiteracy,
        componentTestType: "scientificLiteracy",
        canShowReport: false,
        usesGrade: true,
        testMode: "science-literacy",
    },

    customTest: {
        id: "customTest",
        typeId: 0,
        testTypeId: 7,
        name: "Teste proprii",
        basePath: "/teste-proprii",
        addTestPath: "/teste-proprii/adauga-test",
        tabs: [
            {path: "/teste-proprii", label: "Teste active"},
            {path: "/teste-proprii/teste-finalizate", label: "Teste finalizate"},
            {path: "/teste-proprii/istoric-teste", label: "Istoric teste"},
        ],
        title: "propriu",
        component: CreateTestCustom,
        componentTestType: "customTest",
        canShowReport: false,
        usesGrade: false,
    },
};

export const getTestBasePath = (type: string): string =>
    TEST_TYPES[type as TestType]?.basePath ?? "/teste";

export const getTestTypeId = (type: string): number | undefined =>
    TEST_TYPES[type as TestType]?.typeId;

export const getTestName = (type: string): string => TEST_TYPES[type as TestType]?.name;

export const getTestIdByTestTypeId = (testTypeId: number): TestType | undefined =>
    Object.values(TEST_TYPES).find((config) => config.testTypeId === testTypeId)?.id;

export const getTestNameByTypeId = (testTypeId: number): string =>
    Object.values(TEST_TYPES).find((config) => config.testTypeId === testTypeId)?.name ?? "";
export const getTestMode = (type: string): string | undefined => TEST_TYPES[type as TestType]?.testMode;

